import { Flex } from '@/ui';
import { Text } from '@/ui/typography';
import { dateString } from '@/utils/helpers';
import { getFontSize } from '../utils';

export const InfoColumn = ({
  company,
  person,
  documentType,
  documentNumber,
  verificationId,
  expiration,
  windowWidth
}) => {
  const fontSize = getFontSize(windowWidth);

  return (
    <Flex vertical>
      {expiration && (
        <Text $fontSize={fontSize}>
          Expiration date: {dateString(new Date(expiration))}
        </Text>
      )}
      {company && (
        <Text $fontSize={fontSize}>
          Company: {company}
        </Text>
      )}
      {person && (
        <Text $fontSize={fontSize}>
          Person: {person}
        </Text>
      )}
      {documentType && (
        <Text $fontSize={fontSize}>
          Document type: {documentType}
        </Text>
      )}
      {documentNumber && (
        <Text $fontSize={fontSize}>
          Document number: {documentNumber}
        </Text>
      )}
      {verificationId && (
        <Text $fontSize={fontSize}>
          Session id: {verificationId}
        </Text>
      )}
    </Flex>
  );
};

